import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class SaveContactDetailsSellerService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {HTTPUserRepository} deps.sellerRepository
   */
  constructor({sellerRepository}) {
    super({sellerRepository})

    this._sellerRepository = sellerRepository
  }

  /**
   * @return {Promise<Empty, Error>} returns empty promise
   */

  @inlineError
  async execute({adId, message, name, email, phone, zipCode}) {
    const [error, response] = this._sellerRepository.saveContactDetails({
      adId,
      message,
      name,
      email,
      phone,
      zipCode
    })

    if (error) {
      return Promise.reject(error)
    }

    return response
  }
}
